//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import LinkDeviceModal from './modals/LinkDeviceModal.vue';
import ConfirmSkip from './modals/ConfirmSkip.vue';
import CustomRight from './buttons/CustomRight.vue';
import Previous from './buttons/Previous.vue';
import Finish from './buttons/Finish.vue';
import DataImport from './content/DataImport.vue';
import Step from './steps/Step.vue';
import AppContainer from '../../../../layout/AppContainer.vue';
import UnknownDeviceTypeError from '../../../../../exception/unknownDeviceTypeError';
import Biometrics from '../../../../common/wizard/Biometrics.vue';
import ChooseDevice from '../../../../common/wizard/ChooseDevice.vue';

export default {
  name: 'Setup',
  components: {
    AppContainer,
    Step,
    DataImport,
    Finish,
    Previous,
    CustomRight,
    ConfirmSkip,
    LinkDeviceModal,
    Biometrics,
    ChooseDevice,
  },
  props: ['device'],
  data() {
    return {
      strategy: null,
      vendorCredentials: {
        email: null,
        password: null,
      },
      biometrics: {
        firstName: null,
        lastName: null,
        height: null,
        weight: null,
        prefersMetric: null,
        gender: null,
        birthDate: null,
      },
      deviceTabChange: null,
      importId: null,
      importComplete: false,
      vendorError: null,
      displayModal: true,
    };
  },
  computed: {
    ...mapGetters(['currentImport', 'hotDataIsLoading']),
    deviceName() {
      return this.strategy ? this.strategy.properName() : null;
    },

    origin() {
      if (this.$route.query && this.$route.query.origin) {
        return this.$route.query.origin;
      }
      return null;
    },
  },
  mounted() {
    const user = this.$store.state.user;
    if (user.firstName || user.lastName || user.height || user.weight || user.gender || user.birthDate || user.prefersMetric) {
      this.biometrics = {
        firstName: user.firstName,
        lastName: user.lastName,
        height: user.height,
        weight: user.weight,
        gender: user.gender,
        birthDate: user.birthDate,
        prefersMetric: user.prefersMetric,
      };
      this.$nextTick(() => this.$refs.wizard.nextTab());
    }
    this.$refs.wizard.$on('on-change', (prevIndex, nextIndex) => {
      if (nextIndex === 1 && this.device) {
        this.$nextTick(() => {
          this.handleDeviceType(this.device);
          if (this.$refs.wizard) {
            this.$refs.wizard.nextTab();
          }
        });
      }
    });
    if (this.deviceName === 'Apple') {
      this.$container.eventBus.once('emptyAppleImportDetected', () => {
        this.handleImportComplete();
      });
    }
  },
  methods: {
    showWait() {
      this.wait({
        message: 'We\'re preparing to import your data. It should only take a moment, but may take longer ' +
          'depending on how much data you have.',
        messageSize: 'has-text-gray',
      });
    },
    handleDeviceType(type) {
      try {
        this.strategy = this.$container.setupStrategies[type];
        this.strategy.setVm(this);
        this.$nextTick(() => this.$refs.wizard.nextTab());
      } catch (e) {
        throw new UnknownDeviceTypeError();
      }
    },
    beforeDeviceTabChange() {
      if (this.strategy === null) {
        return false;
      }

      return new Promise((resolve, reject) => {
        this.deviceTabChange = { resolve, reject };
        this.vendorError = null;
        const stopWatching = this.$store.watch(
          state => state.dataImports.lastImport,
          () => {
            this.stopWaiting();
            this.deviceTabChange.resolve(true);
            stopWatching();
          },
        );
        if (this.strategy.properName() === 'Apple') {
          this.handleModalOk();
        } else {
          setTimeout(() => {
            this.$refs.modalMessage.show();
          }, 500);
        }
      });
    },
    async handleModalOk() {
      if (this.strategy.requiresLogin) {
        try {
          await this.$container.di.validateCredentials(
            this.strategy.vendor, {
              email: this.vendorCredentials.email,
              password: this.vendorCredentials.password,
            },
          );
        } catch (e) {
          this.vendorError = e;
          this.stopWaiting();
          return;
        }
      }

      try {
        this.$refs.modalMessage.close();
      } catch (e) {
        console.log(e);
      }
      this.displayModal = false;
      window.addEventListener('noWorkouts', () => {
        this.redirectToHome();
      });
      this.showWait();
      let credentials = null;
      if (this.strategy.requiresLogin) {
        credentials = {
          username: this.vendorCredentials.email,
          password: this.vendorCredentials.password,
        };
      }
      this.strategy.openDeviceLinkingWindow(credentials);
      this.$container.di.startPoller(this.$store.getters.loggedInMember.memberId);
    },
    handleModalCancel() {
      this.stopWaiting();
      this.deviceTabChange.reject();
    },
    async beforeBiometricsTabChange() {
      if (!this.$refs.biometricsForm.isValid) {
        return false;
      }

      this.wait();
      if (!await this.saveBiometricsData(this.biometrics)) {
        this.stopWaiting();
        return false;
      }

      this.stopWaiting();
      return true;
    },
    async saveBiometricsData(biometrics) {
      try {
        const biometricsCopy = Object.assign({}, biometrics);
        console.log(biometricsCopy);
        if (!biometricsCopy.prefersMetric) {
          biometricsCopy.prefersMetric = true;
        }
        if (!biometricsCopy.weight) {
          biometricsCopy.weight = 75;
        }
        if (!biometricsCopy.height) {
          biometricsCopy.height = 1.75;
        }

        await this.$store.commit('updateMember', biometricsCopy);
        await this.$container.memberService.syncMember();
      } catch (e) {
        console.log(e);
        return false;
      }

      return true;
    },
    async handleImportComplete() {
      setTimeout(() => {
        this.importComplete = true;
        this.redirectToHome();
      }, 500);
    },
    skip() {
      this.$refs.confirmSkip.show();
    },
    redirectToHome() {
      if (this.origin) {
        this.$router.push(this.origin);
      } else {
        this.$router.push({
          name: 'dashboard',
        });
      }
    },
  },
};
